export default __webpack_public_path__ + "static/media/bmw.3bf64e6f.svg";